import {RegistrationApiGet, usePutRegistrationByIdMutation} from "./reg_api";
import {Button, Card, CardActions, CardContent, CardMedia, Typography} from "@mui/material";
import React from "react";
import {useNavigate} from "react-router-dom";
import useDownloadImage from "../storage/useDownloadImage";
import userPlaceholder from "/assets/imgs/logo.png";
import {ListCardDataCol} from "../../components/styled";
import Delete from "@mui/icons-material/Delete";
import {ref} from "yup";


interface Props {
    reg: RegistrationApiGet
}

export default ({reg}: Props) => {

    const [put, {error, isLoading}] = usePutRegistrationByIdMutation()
    const avatarUrl = useDownloadImage("machines", reg.machine?.image_url)

    const isMandatory = reg.workTask?.NeedsMachine || false
    const navigate = useNavigate();
    return <Card
        sx={{display: "flex", backgroundColor: isMandatory && !reg.machine ? "error.main": undefined}}
    >
        <CardMedia
            component="img"
            sx={{width: 120, height: 120, minWidth: 120, objectFit: "cover",}}
            image={avatarUrl || userPlaceholder}
            alt={reg.machine?.Name}
            onClick={() => {
                if (reg.Status != "RegFinished") {
                    navigate("./machine")
                }
            }}
        />
        <ListCardDataCol>
        <CardContent>
            <Typography variant={"caption"}>Delovno mesto</Typography>
            <Typography variant={"h3"}>
                {reg.machine?.Name || "N/A"}
            </Typography>
        </CardContent>
            <CardActions>
                {reg.Status != "RegFinished" &&  reg.worker && <Button
                    title="Odstrani delovno mesto"
                    disabled={isLoading}
                    onClick={() => {
                        put({id: reg.id, body: {
                                MachineID: null
                            }})
                    }}
                ><Delete fontSize={"small"}/> </Button>}
            </CardActions>
        </ListCardDataCol>
    </Card>
}
